import store from '@/store';
import FIELD_NAMES from '@/forms/constants/field-names';

const emiratesIdHasBirthYear = (value) => {
  const emiratesIdBirthYear = value.substring(3, 7);
  const userBirth = store.state.formData.values[FIELD_NAMES.birthDate];

  if (!userBirth) {
    return true;
  }
  const userBirthYear = userBirth.substring(0, 4);

  return userBirthYear === emiratesIdBirthYear;
};

export default emiratesIdHasBirthYear;
